import { Routes, Route, Navigate } from "react-router-dom";
import Navigation from "../../components/Navigation/Navigation.js";
import IndividualPreliminaries from "./IndividualPreliminaries/IndividualPreliminaries.js";
import IndividualRound16 from "./IndividualRound16/IndividualRound16.js";
import IndividualRound8 from "./IndividualRound8/IndividualRound8.js";
import IndividualRound4 from "./IndividualRound4/IndividualRound4.js";
import IndividualRound3 from "./IndividualRound3/IndividualRound3.js";
import IndividualRound2 from "./IndividualRound2/IndividualRound2.js";
import Tournament from "./Tournament/Tournament.js";
import Team from "./Team/Team.js";
import Overall from "./Overall/Overall.js";

const GameSummary = () => {
  const tabs = [
    { path: "individual_preliminaries", label: "Individual(Preliminaries)" },
    { path: "individual_round16", label: "Individual(Round of 16)" },
    { path: "individual_round8", label: "Individual(Quarter-finals)" },
    { path: "individual_round4", label: "Individual(Semi-finals)" },
    { path: "individual_round3", label: "Individual(Third Place Match)" },
    { path: "individual_round2", label: "Individual(Finals)" },
    { path: "tournament", label: "Tournament" },
    { path: "team", label: "Team" },
    { path: "overall", label: "Overall" },
  ];

  return (
    <>
      <Navigation tabs={tabs} basePath="/game-summary" variant="sub" />

      <Routes>
        <Route
          path="/"
          element={<Navigate to="individual_preliminaries" replace />}
        />
        <Route path="individual_preliminaries/*" element={<IndividualPreliminaries />} />
        <Route path="individual_round16/*" element={<IndividualRound16 />} />
        <Route path="individual_round8/*" element={<IndividualRound8 />} />
        <Route path="individual_round4/*" element={<IndividualRound4 />} />
        <Route path="individual_round3/*" element={<IndividualRound3 />} />
        <Route path="individual_round2/*" element={<IndividualRound2 />} />
        <Route path="tournament/*" element={<Tournament />} />
        <Route path="team/*" element={<Team />} />
        <Route path="overall/*" element={<Overall />} />
      </Routes>
    </>
  );
};
export default GameSummary;
